export default "__VITE_ASSET__28ef1075__"